import { alpha, AlertTitle, LinearProgress, styled } from '@mui/material'
import { STEADY_DIGITS } from './SessionCountdown.style'

export const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(0.5),
}))

export const Title = styled(AlertTitle)({
  margin: 0,
  fontWeight: 700,
})

export const TimeLeft = styled('span')(({ theme }) => ({
  fontSize: 22,
  fontWeight: 700,
  lineHeight: 1,
  ...STEADY_DIGITS,
  color: theme.palette.warning.dark,
}))

export const TimeLeftBar = styled(LinearProgress)(({ theme }) => ({
  height: 6,
  marginTop: theme.spacing(1.5),
  borderRadius: 3,
  backgroundColor: alpha(theme.palette.warning.main, 0.2),
  '& .MuiLinearProgress-bar': {
    borderRadius: 3,
  },
}))
